import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import HtmlToReact from 'html-to-react';
import { updateShowWaitingAreaParticipant } from '../../../../actions/modal';
let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ContentViewWaitingAreaParticipant(props) {
  const showViewWaitingAreaParticipantModal = useSelector(
    (state) => state.modalReducer.showViewWaitingAreaParticipantModal
  );
  const waitingArea = useSelector((state) => {
    let waitingArea = state.waitingAreaReducer.cleanWaitingArea;

    if (!!state.waitingAreaReducer.selectedWaitingAreaId)
      waitingArea = state.waitingAreaReducer.waitingAreas.find(
        (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
      );

    return waitingArea;
  });

  const dispatch = useDispatch();
  const [participantFormData, setParticipantFormData] = useState(props.participantFormData);
  const [inCallDuration, setInCallDuration] = useState(0);
  const [inRoomTimeHandler, setInRoomTimeHandler] = useState('');

  useEffect(() => {
    if (!props.participantFormData) {
      dispatch(updateShowWaitingAreaParticipant(false));
    }
  }, []);

  useEffect(() => {
    if (!props.participantFormData) {
      dispatch(updateShowWaitingAreaParticipant(false));
    }
  }, [props.participantFormData]);

  const openDeleteHelp = () => {
    window.open(APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpDeleteMeetingRoom, '_blank');
  };

  const calculateInRoomtime = (noFloor) => {
    let timeDiffMilli = new Date(new Date().toISOString()) - new Date(props.participantFormData.joinTime);
    if (!noFloor) return Math.round(timeDiffMilli / 60000);
    else return timeDiffMilli / 60000;
  };

  let inCallDurationLocalVariable = calculateInRoomtime();
  let centerContent = {};
  let bottomContent = {};
  let participantStatus = '';
  let telephone = '';
  let roomName = '';
  let userHasNoCenterPanelContent = props.participantFormData.participantStatus != 'A';

  let getCorrectPhrasingForMinutes = (minutes) => {
    let roundedMinutes = Math.round(minutes);
    if (minutes % 1 == 0)
      //this means no decimal
      return APP.LANGUAGE.WaitingAreaPerson.InRoomFor;
    else if (minutes > roundedMinutes) return APP.LANGUAGE.WaitingAreaPerson.InRoomForMoreThan;
    else if (minutes < roundedMinutes) return APP.LANGUAGE.WaitingAreaPerson.InRoomForLessThan;
  };

  if (props.participantFormData.isPrimaryCaller) participantStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Caller;
  else if (!props.participantFormData.isPrimaryCaller && props.participantFormData.participantStatus == 'T')
    participantStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Guest;
  else if (!props.participantFormData.isPrimaryCaller && props.participantFormData.participantStatus == 'A') {
    if (props.participantFormData.canAnswerCall) participantStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Provider;
    else participantStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Guest;
  }

  if (props.participantFormData.participantStatus == 'T') {
    let waName = waitingArea ? waitingArea.name : '';
    if (props.participantFormData.phone && props.participantFormData.phone != '')
      telephone = (
        <span className="mrlxs">
          <i className="phone icon" />
          {props.participantFormData.phone}
        </span>
      );
  }

  let profileImage = (
    <img
      className="ui image profile "
      src={props.participantFormData.profileImageUrl || window.APP.IMAGES.ProfilePlaceholder.default}
    />
  );
  centerContent = (
    <div className="pdts  ">
      <div className="left-section-caller">{profileImage}</div>
      <div className="right-section-caller" />
    </div>
  );
  bottomContent = (
    <div className="pdnull ui segment ignored info attached message  borderless max-width brdr-radius-null pdrnull ">
      <h3 className="ui header ">
        <i className="ui circle info icon text-size-l " />
        <span className="mrts no-bold text-size-m">{APP.LANGUAGE.DeleteMeeting.Info}</span>
      </h3>
    </div>
  );
  return (
    <Modal
      isSingleColumnModal={true}
      size={'small'}
      show={showViewWaitingAreaParticipantModal}
      hideWhenClickAway={false}
      className={
        'view-waiting-area-participant single-column-modal' +
        (userHasNoCenterPanelContent ? ' no-center-panel-content' : '')
      }
    >
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.ParticipantInfo}
        title={props.participantFormData ? props.participantFormData.name : ''}
        subtitle={
          <span>
            {participantStatus} {telephone}
          </span>
        }
      />
      <div className="content">
        <div
          className={'main-ui-container meeting-room-create-update ' + (userHasNoCenterPanelContent ? ' mrrnull' : '')}
        >
          <div id="righthandfloatingpanel">
            {!userHasNoCenterPanelContent ? centerContent : ''}
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanel
                participantCanDisconnect={props.participantCanDisconnect}
                participantFormData={props.participantFormData}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
